import { jsx as _jsx } from "react/jsx-runtime";
import {} from "react";
import { useMediaQuery, useTheme } from "@mui/material";
import { AppDrawerDesktop } from "./AppDrawerDesktop.js";
import { AppDrawerDivider, AppDrawerListItem } from "./AppDrawerItems.js";
import { AppDrawerMobile } from "./AppDrawerMobile.js";
export { AppDrawerDivider, AppDrawerListItem };
/**
 * A re-usable application drawer component which caters for mobile and desktop.
 *
 * The default `drawerWidth` is expressed in `rem` so that it scales
 * automatically when users apply WCAG 1.4.4 text-size zoom (e.g. the 200%
 * bookmarklet that sets `<html>` `font-size`).
 */
export const AppDrawer = (props) => {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
    // "15.625rem" == 250px at the browser default of 16px, but scales with
    // root font-size zoom (250px × 2 = 500px at 200% text size).
    const newProps = { drawerWidth: "15.625rem", ...props };
    return isDesktop ? (_jsx(AppDrawerDesktop, { ...newProps })) : (_jsx(AppDrawerMobile, { ...newProps }));
};
//# sourceMappingURL=AppDrawer.js.map